import React from "react";
import context from "lib/stores/context";
import { useSnapshot } from "valtio";

const Icon = ({ active = false, onClickAsc = () => {}, onClickDesc = () => {} }) => {
  const { sortTableOrder } = useSnapshot(context);

  return (
    <svg fill="none" height="13" viewBox="0 0 6 10" width="9" xmlns="http://www.w3.org/2000/svg">
      <path
        className="cursor-pointer"
        onClick={() => onClickAsc()}
        d="M0 4 H0 l3-4 3 4z"
        fill={active && sortTableOrder === "asc" ? "#000028" : "#D6D6DE"}
      />
      <path
        className="cursor-pointer"
        onClick={() => onClickDesc()}
        d="M0 6 h6 l-3 4 -3-4z"
        fill={active && sortTableOrder === "desc" ? "#000028" : "#D6D6DE"}
      />
    </svg>
  );
};

export default Icon;
